"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesVideoTypeGroupSchema = void 0;
exports.ServicesVideoTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/video.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesVideoTypeGroup",
    "description": "ServicesVideoTypeGroup represents one of the following types: MediaPartnershipsVideo, MediabaseDeliveryAgentClips, MediabaseDeliveryAgentClips, RallyTvVideo1, RBMNLive, RBMNVideo, BrightcoveVRVideo, RedBullTVLinearStream, RedBullTVLiveVideostream, RedBullTVVideo, ServusTVLiveVideo, ServusTVVideo, TwitchLiveVideo, TwitchLiveVideo, VimeoVideo, VKVideo, YoutubePlaylist, YoutubeShort, YoutubeVideo",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/media-partnerships-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/mediabase-delivery-agent-clip/3.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rally-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_com-vr-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-linear-stream/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vimeo-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/vk-video/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-playlist/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-short/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/youtube-video/1.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvdHlwZS1ncm91cHMvc2VydmljZXMvdmlkZW8uc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNEJBQTRCLEdBQUc7SUFDMUMsS0FBSyxFQUFFLHdFQUF3RTtJQUMvRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx3QkFBd0I7SUFDakMsYUFBYSxFQUFFLDhZQUE4WTtJQUM3WixPQUFPLEVBQUU7UUFDUDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSw2RkFBNkY7U0FDdEc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrR0FBa0c7U0FDM0c7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrR0FBa0c7U0FDM0c7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxtRkFBbUY7U0FDNUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSw4RUFBOEU7U0FDdkY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSwrRUFBK0U7U0FDeEY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx5RkFBeUY7U0FDbEc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSw2RkFBNkY7U0FDdEc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxvRkFBb0Y7U0FDN0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSx3RkFBd0Y7U0FDakc7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxvRkFBb0Y7U0FDN0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxnRkFBZ0Y7U0FDekY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSw2RUFBNkU7U0FDdEY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxxRkFBcUY7U0FDOUY7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrRkFBa0Y7U0FDM0Y7UUFDRDtZQUNFLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRSxrRkFBa0Y7U0FDM0Y7S0FDRjtDQUNGLENBQUEifQ==